const BREATHING_ROOM = 50;

const getScrollOffset = (stickyNav) => {
  const header = document.querySelector('header');
  const headerH = header?.offsetHeight ?? 0;
  const navH = stickyNav?.offsetHeight ?? 0;

  return headerH + navH + BREATHING_ROOM;
};

const smoothScrollToHash = (hash, stickyNav) => {
  if (!hash || hash === '#') return false;
  const targetId = hash.substring(1);
  const target = document.querySelector(`#${CSS.escape(targetId)}`);
  if (!target) {
    console.warn(`[sticky-sub-nav] No element with id="${targetId}" found.`);
    return false;
  }
  const offset = getScrollOffset(stickyNav);
  const position = target.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: position, behavior: 'smooth' });
  return true;
};

/**
 * Flags whether the list overflows and whether there is more content hidden off
 * each edge, so the CSS can fade only the edge that actually has more behind it.
 */
const updateScrollAffordance = (list) => {
  const maxScroll = list.scrollWidth - list.clientWidth;
  // Sub-pixel widths mean scrollLeft rarely hits the bounds exactly.
  const TOLERANCE = 1;
  const isOverflowing = maxScroll > TOLERANCE;

  list.dataset.overflowing = isOverflowing ? 'true' : 'false';
  list.dataset.moreBefore = isOverflowing && list.scrollLeft > TOLERANCE ? 'true' : 'false';
  list.dataset.moreAfter = isOverflowing && list.scrollLeft < maxScroll - TOLERANCE ? 'true' : 'false';
};

export const initStickySubNav = () => {
  const navs = document.querySelectorAll('.sticky-sub-nav');
  if (!navs.length) return;

  navs.forEach(nav => {
    const list = nav.querySelector('.sticky-sub-nav__list');

    if (list) {
      const update = () => updateScrollAffordance(list);
      update();
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Fonts landing late change item widths, which changes whether it overflows.
      document.fonts?.ready.then(update);

      // Keep a link reachable by keyboard when it's scrolled out of view.
      list.querySelectorAll('.sticky-sub-nav__link').forEach(link => {
        link.addEventListener('focus', () => {
          link.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      });
    }

    nav.querySelectorAll('.sticky-sub-nav__link').forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href') || '';

        if (href.startsWith('#')) {
          if (smoothScrollToHash(href, nav)) {
            e.preventDefault();
          }
        }
      });
    });
  });

  // Cross-page links land with the hash already in the URL; the browser's own
  // jump ignores the fixed header + sticky bar, so re-scroll with the offset.
  if (window.location.hash) {
    setTimeout(() => smoothScrollToHash(window.location.hash, navs[0]), 100);
  }
};
